import { createReducer, on } from '@ngrx/store';
import { AppleDeviceApiActions } from './os-update-states.actions';
import { adapter, initialState } from './os-update-states.state';

export const MdmOsUpdateStatesFeatureKey = 'getOsUpdateStatuses';

export const OsUpdateStatesReducer = createReducer(
  initialState,
  on(AppleDeviceApiActions.osUpdateStateLoaded, (state, { osUpdateStatusses }) =>
    adapter.upsertMany(osUpdateStatusses, state)
  )
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectOsUpdateStatussesIds = selectIds;

export const selectOsUpdateStatussesEntities = selectEntities;

export const selectOsUpdateStatusses = selectAll;
